export const GOOGLEAPIS_URL = 'https://fonts.googleapis.com';
export const GOOGLEAPIS_STATIC_URL = 'https://fonts.gstatic.com';

const FAMILY = [
  `Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900`,
  `Murecho:wght@100..900`,
  `Noto+Sans+JP:wght@100..900`,
];
export const GOOGLE_FONTS_URL = `${GOOGLEAPIS_URL}/css2?family=${FAMILY.join('&family=')}&display=swap`;
